import { Injectable, OnDestroy, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class WindowHeightService implements OnDestroy {
  height$: Observable<number>;

  private windowHeight = 0;
  private lastWindowHeight = 0;
  private timerId: ReturnType<typeof setInterval> | null = null;
  private readonly heightSource$ = new BehaviorSubject<number>(0);

  constructor(@Inject(PLATFORM_ID) private readonly platformId: NonNullable<unknown>) {
    this.height$ = this.heightSource$.asObservable();
  }

  init(): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    if (this.timerId !== null) {
      return;
    }

    const INTERVAL = 500;
    this.windowHeight = window.innerHeight;
    this.lastWindowHeight = this.windowHeight;
    this.heightSource$.next(this.windowHeight);

    this.timerId = setInterval(() => {
      const h = window.innerHeight;
      if (this.lastWindowHeight !== h) {
        this.lastWindowHeight = h;
        this.heightSource$.next(h);
      }
    }, INTERVAL);
  }

  ngOnDestroy(): void {
    if (this.timerId !== null) {
      clearInterval(this.timerId);
      this.timerId = null;
    }
  }
}
